import { useEffect } from 'react';

import { URL_PARAMS_KEY } from '@/constants';
import { useLoginAuth } from '@/features/auth';
import { useUrlParameter } from '@/hooks/useUrlParameter';
import { captureAdParams } from '@/utils/ad';

/**
 * ようこそ画面(サインアップ)用 カスタムフック
 */
export const useSignUp = () => {
  const { findParams } = useUrlParameter();
  const serialCode = findParams(URL_PARAMS_KEY.SERIAL.code);
  const { loginAuth } = useLoginAuth({
    code: serialCode,
  });

  useEffect(() => {
    // 広告パラメータをURLから取得し保存
    captureAdParams();
    // 認証実行
    loginAuth(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
